import { connect } from 'react-redux';
import createReactClass from 'create-react-class';
import get from 'lodash/get';
import PasswordStrengthBar from 'react-password-strength-bar';
import React from 'react';
/** import third-party libraries in the section above, Sort Lines Ascending */

import { BlockLoadGroup } from 'widgets-v5/load-group';
import { PrimaryButton, ButtonGroup } from 'widgets-v5/buttons';
import Card from 'widgets-v5/card';
import CenterLayout from 'widgets-v5/center-layout';
import FormField from 'widgets-v5/form-field';
/** import widgets in the section above, Sort Lines Ascending */

import { activateEdit as Action_activateEdit } from 'pages/activate/actions';
import { redirectIfMissingToken, redirectLoggedInUserFromTokenLink } from 'common/token-link-guard';
import selector from './selector';
/** import single application imports in the section above, Sort Lines Ascending */

const Activate = createReactClass({
    displayName: 'Activate',

    statics: {
        /**
         * Called on route refresh by the global refresh wrapper, which passes
         * (dispatch, nextState, browserHistory.push) — the 3rd argument is NOT profile.
         * Profile-based redirect is therefore handled in init() where props are available.
         *
         * @param {Function} dispatch - Redux dispatch
         * @param {{ location: { query: { token?: string } } }} nextState - React Router next state
         */
        refresh(dispatch, nextState) {
            // Check for missing token — redirects to home with error toast if absent
            if (redirectIfMissingToken(nextState.location, 'token')) {
                return;
            }

            const activationToken = (get(nextState, 'location.query.token') || '').trim();
            dispatch(Action_activateEdit.open(activationToken));
        },
    },

    init() {
        const { dispatch, location, params, routes, profile } = this.props;
        const nextState = { location, params, routes };

        // Check if user is already logged in — redirect with warning toast if so.
        // Done here (not in statics.refresh) because the global refresh wrapper passes
        // browserHistory.push as the 3rd arg, not the profile object.
        if (redirectLoggedInUserFromTokenLink(profile, (location.query?.token || '').trim())) {
            return;
        }

        Activate.refresh(dispatch, nextState);
    },

    componentDidMount() {
        this.init();
    },

    onFieldChange(fieldName) {
        return fieldValue => {
            const newFormData = {
                [fieldName]: fieldValue,
            };

            this.props.dispatch(Action_activateEdit.updateDraft(newFormData));
        };
    },

    handleSubmit(e) {
        e.preventDefault();
        this.props.dispatch(Action_activateEdit.submitDraft());
    },

    render() {
        const draft = this.props.draft;
        const errors = this.props.errors;
        const showErrors = this.props.showErrors;
        const fetchError = this.props.fetchError;
        const email_login_enabled = draft?.email_login_enabled;

        // From GET /activation/:token — Urban sets email_login_enabled on the user behind the token.
        const hidePassword = email_login_enabled;

        return (
            <CenterLayout className="ef5-activate">
                <BlockLoadGroup size="large" isLoading={this.props.isLoading}>
                    <img className="ef5-activate__logo" src="/images/EngageFront-logo.png" />
                    <Card
                        className="ef5-activate__card"
                        title="Account Activation"
                        footer={
                            // Invalid/expired token from GET: hide submit, show fetchError below.
                            fetchError ? null : (
                                <ButtonGroup>
                                    <PrimaryButton text="Activate" onClick={this.handleSubmit} />
                                </ButtonGroup>
                            )
                        }
                    >
                        {fetchError ? (
                            <FormField showErrors={true} errors={[fetchError]} />
                        ) : (
                            <form ref="login-form" method="POST" onSubmit={this.handleSubmit}>
                                <FormField label="E-mail address" isRequired={true}>
                                    <input
                                        className="ef3-stdInput"
                                        type="text"
                                        value={draft.email}
                                        disabled={true}
                                    />
                                </FormField>
                                <FormField
                                    label="First Name"
                                    errors={errors.first_name}
                                    showErrors={showErrors}
                                    isRequired={true}
                                >
                                    <input
                                        className="ef3-stdInput"
                                        type="text"
                                        value={draft.first_name}
                                        onChange={e => {
                                            this.onFieldChange('first_name')(e.target.value);
                                        }}
                                    />
                                </FormField>
                                <FormField
                                    label="Last Name"
                                    errors={errors.last_name}
                                    showErrors={showErrors}
                                    isRequired={true}
                                >
                                    <input
                                        className="ef3-stdInput"
                                        type="text"
                                        value={draft.last_name}
                                        onChange={e => {
                                            this.onFieldChange('last_name')(e.target.value);
                                        }}
                                    />
                                </FormField>
                                {!hidePassword && (
                                    <>
                                        <FormField
                                            label="Password"
                                            errors={errors.password}
                                            showErrors={showErrors}
                                            isRequired={true}
                                        >
                                            <input
                                                className="ef3-stdInput"
                                                type="password"
                                                defaultValue=""
                                                onChange={e => {
                                                    this.onFieldChange('password')(e.target.value);
                                                }}
                                            />
                                            <PasswordStrengthBar
                                                className="ef5-reset-password__strength-meter"
                                                minLength={12}
                                                password={draft.password}
                                                onChangeScore={score => {
                                                    this.onFieldChange('password_strength')(score);
                                                }}
                                            />
                                        </FormField>
                                        <FormField
                                            label="Confirm Password"
                                            errors={errors.confirmPassword}
                                            showErrors={showErrors}
                                            isRequired={true}
                                        >
                                            <input
                                                className="ef3-stdInput"
                                                type="password"
                                                defaultValue=""
                                                onChange={e => {
                                                    this.onFieldChange('confirmPassword')(
                                                        e.target.value
                                                    );
                                                }}
                                            />
                                        </FormField>
                                        <div className="ef3-formField_description is-error">
                                            <div>
                                                {' '}
                                                {showErrors && errors.passwordsMatches
                                                    ? errors.passwordsMatches
                                                    : null}
                                            </div>
                                        </div>
                                    </>
                                )}
                                <FormField errors={errors['']} showErrors={showErrors} />
                            </form>
                        )}
                    </Card>
                </BlockLoadGroup>
            </CenterLayout>
        );
    },
});

const connectedComponent = connect(selector)(Activate);

export default connectedComponent;
